import { useEffect, useState } from 'react';
import { FaFacebook } from 'react-icons/fa';
import {
  BrowserRouter as Router,
  Link,
  NavLink,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';

import About from './components/pages/About';
import Contact from './components/pages/Contact';
import Content from './components/pages/Content';
import Home from './components/pages/Home';

function AppContent() {
  const baseUrl = import.meta.env.BASE_URL;
  const [isNavOpen, setIsNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsNavOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen w-full max-w-full overflow-hidden">
      <header className="navbar">
        <div className="container nav-container">
          <Link to="/" className="nav-logo">
            <img
              src={`${baseUrl}assets/logo_photos/MFC-cross_logo-02.svg`}
              alt="Ministries For Christ cross logo"
              className="nav-logo-mark"
              width={34}
              height={50}
            />
            <span>Ministries For Christ</span>
          </Link>
          <button
            type="button"
            className="nav-toggle"
            onClick={() => setIsNavOpen((open) => !open)}
            aria-expanded={isNavOpen}
            aria-controls="main-nav"
            aria-label={isNavOpen ? 'Close navigation menu' : 'Open navigation menu'}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <nav id="main-nav" className={`nav-links${isNavOpen ? ' nav-links-open' : ''}`}>
            <NavLink to="/" className={({ isActive }) => (isActive ? 'nav-link-active' : '')} end>
              Home
            </NavLink>
            <NavLink to="/about" className={({ isActive }) => (isActive ? 'nav-link-active' : '')}>
              About Us
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) => (isActive ? 'nav-link-active' : '')}
            >
              Contact
            </NavLink>
            <NavLink
              to="/content"
              className={({ isActive }) => (isActive ? 'nav-link-active' : '')}
            >
              Content
            </NavLink>
          </nav>
        </div>
      </header>

      <main className="main-with-fixed-nav flex-grow py-8 w-full overflow-x-hidden">
        <div className="container mx-auto px-4">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/content" element={<Content />} />
          </Routes>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4">Ministries For Christ</h3>
            <p className="mb-4">Spreading the love and teachings of Jesus Christ to all nations.</p>
            <div className="flex justify-center space-x-4 mb-6">
              <a
                href="https://www.facebook.com/profile.php?id=61573569402755&sk=about"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-brand-sand"
                aria-label="Facebook"
              >
                <FaFacebook className="text-2xl" />
              </a>
            </div>
            <p className="text-sm">
              &copy; {new Date().getFullYear()} Ministries For Christ. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
